module.exports = __webpack_public_path__ + "img/users-icon.29bec51d.svg";